import styled from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'
import { brandConfig } from '../../../config/brandConfig'
import Link from '../link'

export const StyledTitlesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 4em;

  a {
    text-decoration: none;
  }
`

export const StyledTitle = styled.span`
  font-size: ${brandConfig.fonts.text.small.size.mobile};

  ${themeMedia.desktop`
    font-size: ${brandConfig.fonts.text.small.size.desktop};
  `}

  line-height: 1.3em;
  padding: 0.3em 0 0.4em;
  color: ${themeStyles.colors.white.main};
`

export const StyledSubtitle = styled(Link)`
  font-size: 10px;
  text-transform: uppercase;
  color: ${themeStyles.colors.accentColors.secondary.main};

  ${themeMedia.desktop`
    font-size: ${brandConfig.fonts.text.small.size.mobile};
  `}
`
